import { UiModalContent } from 'components';
import { utils } from 'lib';
import { observer } from 'mobx-react';
import times from 'lodash/times';
import { useEffect } from 'react';
import { useArray, useBoolean, useNumber } from 'react-hanger';
import styled from 'styled-components';
import service from './service';
import defaultPic from './images/avatar-bg.png';

const Item = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  box-sizing: border-box;
  padding: 80px 40px 0;
  text-align: center;
  background: url(${require('./images/popup-bg-history.png')}) 0 0 / contain no-repeat;
  width: 300px;
  height: 460px;
  z-index: 1;
  transition: transform 0.4s linear, opacity 0.4s linear;
  //display: none;
  transform: scale(0.6);

  .title {
    font-size: 14px;
    font-weight: 600;
    line-height: 28px;
    text-align: center;
    color: #795b51;
  }

  .time {
    font-size: 12px;
    font-weight: normal;
    line-height: 14px;
    color: #e5c5a9;
    text-align: center;
  }

  .info {
    display: flex;
    justify-content: space-between;
    background: url(${require('./images/gift.png')}) center -16px / contain no-repeat;
    background-size: 120px 120px;

    &__item {
      position: relative;
      width: 80px;
      text-align: center;
      color: #795b51;
      padding-top: 10px;
      font-size: 12px;

      &--user:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background: url(${require('./images/avatar-mask-blue.png')}) 0 0 / contain no-repeat;
        width: 80px;
        height: 80px;
      }

      &--star:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background: url(${require('./images/avatar-mask-red.png')}) 0 0 / contain no-repeat;
        width: 80px;
        height: 80px;
      }

      img {
        width: 54px;
        height: 54px;
        border-radius: 50%;
        vertical-align: top;
      }

      .text-overflow {
        max-width: 5em;
        margin-top: 12px;
      }
    }
  }

  .timer-name {
    color: #d688a4;
    padding-top: 8px;
    font-size: 12px;
  }

  .users {
    //padding: 12px 0 0;
    margin: 16px -10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    height: 140px;
    overflow: auto;
    mask: linear-gradient(to bottom, #ffffff 85.63%, rgba(255, 255, 255, 0) 100%);

    .users__item {
      display: inline-block;
      font-size: 10px;
      color: #795b51;
      width: 54px;
      line-height: 14px;
      text-align: center;
      height: 80px;

      &__pic {
        background: url(${require('./images/avatar-bg.png')}) 0 0 / contain no-repeat;
        background-size: 44px 44px;
        width: 44px;
        height: 44px;
        padding: 2px;
        box-sizing: border-box;
        margin: 0 auto;

        img {
          width: 40px;
          height: 40px;
          vertical-align: top;
          border-radius: 50%;
        }
      }

      .text-overflow {
        max-width: 5em;
      }
    }
  }
`;

const Wrap = styled.div`
  width: 300px;
  height: 460px;
  position: relative;

  .empty {
    background: url(${require('./images/history-empty.png')}) 0 0 / contain no-repeat;
    width: 300px;
    height: 460px;
  }

  .prev {
    z-index: 2;
    opacity: 0.9;
    transform: translateX(-70px) scale(0.8);
    cursor: pointer;
    display: block;
  }

  .next {
    z-index: 2;
    opacity: 0.9;
    transform: translateX(70px) scale(0.8);
    cursor: pointer;
    display: block;
  }

  .current {
    transform: scale(1);
    z-index: 10;
    display: block;
  }

  .close {
    position: absolute;
    bottom: -20px;
    left: 50%;
    margin-left: -14px;
    background: url(${require('./images/close.png')}) 0 0 / contain no-repeat;

    width: 28px;
    height: 28px;
  }
`;

const PopupHistory = observer((props) => {
  const { onClose } = props;

  const list = useArray([]);
  const activeIndex = useNumber(0);
  const showEmpty = useBoolean(false);

  useEffect(() => {
    service.loadHistory().then((res) => {
      // res.data = [
      //   {
      //     timestamp: 0,
      //     user: {
      //       uid: 11111,
      //       nick_name: '昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称',
      //       pic: 'https://www.2339.com/1.png',
      //     },
      //     star: {
      //       uid: 11111,
      //       nick_name: '昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称',
      //       pic: 'https://www.2339.com/1.png',
      //     },
      //     wish_list: [
      //       {
      //         uid: 11111,
      //         nick_name: '昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称昵称',
      //         pic: 'https://www.2339.com/1.png',
      //         wish: 333,
      //       },
      //     ],
      //   },
      // ];
      list.setValue(
        res.data.map((item) => {
          if (item.wish_list.length < 8) {
            item.wish_list = item.wish_list.concat(
              times(8 - item.wish_list.length, (index) => {
                return {
                  uid: index,
                  nick_name: '虚位以待',
                  wish: -1,
                };
              }),
            );
          }
          return item;
        }),
      );
      showEmpty.setValue(res.data.length === 0);
    });
  }, []);

  const handleIndex = (inc) => {
    if (inc) {
      activeIndex.setValue(activeIndex.value + inc);
    }
  };

  return (
    <UiModalContent maskEnable={false}>
      <Wrap>
        {showEmpty.value && <div className="empty"></div>}
        {list.value.map((item: any, index) => {
          let type = '';
          if (index + 1 === activeIndex.value) {
            type = 'prev';
          } else if (activeIndex.value === index - 1) {
            type = 'next';
          } else if (index === activeIndex.value) {
            type = 'current';
          }

          return (
            <Item
              key={item.timestamp}
              onClick={() => {
                handleIndex({ prev: -1, next: 1 }[type]);
              }}
              className={`${type}`}
            >
              <div className="title">仪式纪念</div>
              <div className="time">{utils.formatTime(item.timestamp, 'yyyy.MM.dd hh:mm:ss')}</div>
              <div className="info">
                <div className="info__item info__item--user">
                  <div>
                    <img src={item.user.pic} alt="" />
                  </div>
                  <div className="text-overflow">{item.user.nick_name}</div>
                </div>
                <div className="info__item  info__item--star">
                  <div>
                    <img src={item.star.pic} alt="" />
                  </div>
                  <div className="text-overflow">{item.star.nick_name}</div>
                </div>
              </div>

              <div className="timer-name">感谢我们的仪式有您的见证！</div>
              <div className="users">
                {item.wish_list.map((wishUser) => {
                  return (
                    <div className="users__item" key={wishUser.uid}>
                      <div className="users__item__pic">
                        {wishUser.pic && <img src={wishUser.pic} alt="" />}
                      </div>
                      <div className="text-overflow">{wishUser.nick_name}</div>
                      {wishUser.wish > 0 && (
                        <div className="text-overflow">{wishUser.wish} 祝福值</div>
                      )}
                    </div>
                  );
                })}
              </div>
            </Item>
          );
        })}

        <button className="close" onClick={onClose}></button>
      </Wrap>
    </UiModalContent>
  );
});

export default PopupHistory;
